// CryptoJS's default AES output is base64 with an embedded "Salted__" prefix
// (base64-encoded as "U2FsdGVk..."). New /images-preview/ links carry a short
// opaque token instead (TA-10212); this prefix check distinguishes the two so
// links shared before the rollout keep resolving.
const LEGACY_AES_PREFIX = 'U2FsdGVk';

export const isLegacyMediaShareSegment = (segment: string): boolean =>
  segment.startsWith(LEGACY_AES_PREFIX);

// A short /images-preview/:token link can pick up a trailing slash (copy/paste
// from a URL bar or a link opened with a trailing "/"), or a query string /
// hash fragment (email/Slack link previews, deep-link handlers that forward
// the full URL tail). None of that belongs in the token, so strip it before
// storing/using the value — otherwise the sharedMediaByToken lookup 404s.
export const sanitizeShareToken = (segment: string): string =>
  segment.split(/[?#]/)[0].replace(/\/+$/, '');

// The legacy AES branch can also receive a segment with a trailing query
// string / hash fragment (email/Slack link previews, deep-link handlers that
// forward the full URL tail), which breaks CryptoJs.AES.decrypt on otherwise
// valid ciphertext. Strip only the query/hash here — unlike sanitizeShareToken,
// this must NOT strip a trailing slash: legacy ciphertext is base64, and "/"
// is a valid, position-significant base64 character, so trimming it could
// corrupt otherwise-valid ciphertext.
export const stripShareSegmentQueryAndHash = (segment: string): string =>
  segment.split(/[?#]/)[0];
